// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".atlas4-loader {\n    height: 100%;\n    width: 100%;\n    background: #101117;\n    z-index: 9999;\n    position: absolute;\n}\n\n.atlas4-loader div {\n    height: 100px;\n    width: 100px;\n    display: inline-block;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}", ""]);
// Exports
module.exports = exports;
